const files = require.context('.', true, /\.js/)

let configRouters = []

files.keys().forEach((key) => {
	if (key === './index.js') {
		return
	}
	configRouters = configRouters.concat(files(key).default)
})
// console.log(configRouters)
export default configRouters



// WEBPACK FOOTER //
// ./src/router/modules/index.js